var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthLayout',{attrs:{"current-step":_vm.currentStep,"steps-count":2,"many-steps":""}},[_c('CompleteContainer',{model:{value:(_vm.currentStep),callback:function ($$v) {_vm.currentStep=$$v},expression:"currentStep"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }